module.exports = __webpack_public_path__ + "static/playstore-e7acdf93cad34fac67ba1efaa451b0d1.png";